import flatten from 'flat'

import * as defaultMessages from './locales/default.json'

/** Flattens the app's own nested message catalog into the flat key→string map `IntlProvider` expects. */
export const buildAppMessages = (): Record<string, string> => flatten(defaultMessages)
